/** Offset navbar principale seule (fiche programme sans sous-nav). */
export const SITE_PROJECT_MAIN_PADDING_EXPANDED =
  'pt-[5.5rem] sm:pt-[6rem] md:pt-[6.5rem]';

export const SITE_PROJECT_MAIN_PADDING_COLLAPSED =
  'pt-3 sm:pt-4';
